import { useNavigate } from 'react-router-dom';

export const SubscriptionSuccess = () => {
    const navigate = useNavigate();
    localStorage.setItem('package', 'full');
    return (
        <div className="p-2 lg:p-8">
            <div className="text-2xl font-bold mb-8 text-center">Subscription Success</div>
            <div className="text-center">
                <p>Your subscription has been successfully upgraded.</p>
            </div>
            <div className="text-center mt-8">
                <button className="bg-blue-500 text-white px-4 py-2 rounded-md" onClick={() => navigate('/dashboard')}>
                    Go to Dashboard
                </button>
            </div>
        </div>
    )
}   

